import { render, staticRenderFns } from "./ActionButtonConfiguringComponent.vue?vue&type=template&id=fddd76f6&"
import script from "./ActionButtonConfiguringComponent.vue?vue&type=script&lang=js&"
export * from "./ActionButtonConfiguringComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports